export default __webpack_public_path__ + "static/AppMoneyWalkie12-543964b00c5efe08f1d25724ede912c8.png";